import { isEmpty } from 'lodash';

type badgePermissionValue = {
  badge_ids?: string[];
  official_badge_ids?: string[];
};

export const transformBadgeIdToValue = (id: string): badgePermissionValue => {
  const isOfficialBadge = id?.startsWith('official_');
  return isOfficialBadge
    ? { official_badge_ids: [id.replace('official_', '')] }
    : { badge_ids: [id] };
};

export const valueToBadgeId = (value: badgePermissionValue) => {
  if (!isEmpty(value?.badge_ids)) {
    return value?.badge_ids?.[0];
  } else if (!isEmpty(value?.official_badge_ids)) {
    return `official_${value?.official_badge_ids?.[0]}`;
  } else {
    return '';
  }
};
